import { Skeleton } from '@zorro/design-system/v2/Skeleton';
import { Box, Flex } from '@zorro/web/design-system';

const SkeletonDataTable = () => {
  return (
    <Box
      w="100%"
      style={{ borderLeft: '1px solid #F0F1F3', overflow: 'hidden' }}
    >
      {/* Header row */}
      <Flex
        h="3rem"
        align="center"
        bg="var(--color-background-system-secondary)"
        style={{
          borderBottom: '1px solid var(--color-background-system-secondary)',
          borderTopLeftRadius: 8,
        }}
      >
        {/* Checkbox column header */}
        <Flex w={65} h="100%" justify="center" align="center">
          <div
            style={{
              width: 16,
              height: 16,
              border: '1px solid #A4A5AF',
              borderRadius: 2,
            }}
          />
        </Flex>
        {/* Name column header — skeleton bar */}
        <Box style={{ width: 163, padding: '0 1rem' }}>
          <Skeleton h={13} w="100%" />
        </Box>
        {/* Small icon column header — empty */}
        <Box style={{ width: 60 }} />
        {/* Remaining column headers */}
        {['hcol3', 'hcol4', 'hcol5', 'hcol6'].map((key) => (
          <Box key={key} style={{ flex: 1, padding: '0 1rem' }}>
            <Skeleton h={13} w="100%" />
          </Box>
        ))}
      </Flex>

      {/* Data rows */}
      {[
        'skrow1',
        'skrow2',
        'skrow3',
        'skrow4',
        'skrow5',
        'skrow6',
        'skrow7',
        'skrow8',
        'skrow9',
        'skrow10',
      ].map((rowKey) => (
        <Flex
          key={rowKey}
          h="3.75rem"
          align="center"
          style={{
            borderBottom: '1px solid var(--color-background-system-secondary)',
          }}
        >
          {/* Checkbox cell */}
          <Flex w={65} justify="center" align="center">
            <div
              style={{
                width: 16,
                height: 16,
                border: '1px solid #A4A5AF',
                borderRadius: 2,
              }}
            />
          </Flex>
          {/* Name cell: avatar circle + skeleton bar */}
          <Flex
            align="center"
            gap="sm"
            style={{ width: 163, padding: '0 1rem' }}
          >
            <Skeleton h={26} w={26} radius={100} />
            <Box style={{ flex: 1 }}>
              <Skeleton h={13} w="100%" />
            </Box>
          </Flex>
          {/* Small icon cell — 13×13 rounded square */}
          <Flex w={60} justify="center" align="center">
            <Skeleton h={13} w={13} radius={3} />
          </Flex>
          {/* Remaining data cells */}
          {['dcol3', 'dcol4', 'dcol5', 'dcol6'].map((colKey) => (
            <Box key={colKey} style={{ flex: 1, padding: '0 1rem' }}>
              <Skeleton h={13} w="100%" />
            </Box>
          ))}
        </Flex>
      ))}
    </Box>
  );
};

export default SkeletonDataTable;
